function reducer(state = [], action) {
    switch (action.type) {
        case 'GENDERS/SET':
            return action.genders;
        case 'GENDER/CLEAR':
            return null;
        default:
            return state;
    }
}

export default reducer;
